/**
 * A global namespace for aria-checked.
 */
const ariaChecked = "aria-checked";
export default ariaChecked;
